var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-date-picker',_vm._b({staticClass:"date-picker-box",attrs:{"value":_vm.value,"picker-date":_vm.pickerDate},on:{"update:pickerDate":function($event){_vm.pickerDate=$event},"update:picker-date":function($event){_vm.pickerDate=$event},"input":_vm.update}},'v-date-picker',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }